/**
 * King Living Routes
 *
 * Extends the base retail app routes with custom King Living routes.
 */

import loadable from '@loadable/component';

import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config';
import {Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui';
import {routes as baseRoutes} from '@salesforce/retail-react-app/app/routes';
import {configureRoutes} from '@salesforce/retail-react-app/app/utils/routes-utils';

const fallback = <Skeleton height="75vh" width="100%" />;
const ExamplesPage = loadable(() => import('./pages/examples'), {fallback});
const Page = loadable(() => import('@amblique/contentful/app/pages/page'), {fallback});

export const routes = [
  {
    path: '/page/:slug',
    component: Page,
  },
  {
    path: '/examples',
    component: ExamplesPage,
    exact: true,
  },
  ...baseRoutes
];

export default () => {
  const config = getConfig();

  return configureRoutes(routes, config, {
    ignoredRoutes: ['/callback', '*'],
  });
};
